

import { IState } from '../../../../core/IState';
import { RequestDetailEditController } from '../controllers/requestDetailEditController';
import '../services/requestDetailEditService';
import '../directives/shipmentDetailEdit/shipmentDetailEditDirective';
import '../directives/shipmentMaterialEdit/shipmentMaterialEditDirective';
import '../directives/requestLetterEdit/requestLetterEditDirective';

export const requestDetailEditState: IState = {
    name: 'requests.requestDetailEdit',
    url: '/detailEdit/{trackingId}',
    controller: RequestDetailEditController,
    controllerAs: 'vm',
    template: require('../templates/requestDetailEdit.html'),
    data: {
        title: 'Requests',
        navParent: 'requests',
        requiredActivity : 'requests'
    }
};

angular.module('deliveryCreate.app').config(['$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state(requestDetailEditState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/states/requestDetailEditState.ts
 **/